'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Fragment, useState } from 'react';
import { Link } from '@/frontend/design-system/actions/Link';
import { AlgoAcademyHorizontalLogo } from '../../../logos/AlgoAcademyHorizontalLogo';
import { MobileMenuDisclosure } from '../_components/MobileMenuDisclosure';
import { MobileMenuLink } from '../_components/MobileMenuLink';
import { aboutLinks, elementarySchoolCourses, highSchoolCourses, manageSiteLinks, mentoringLinks, universityCourses } from '../_components/NavigationItems';
export function NavbarMobile(t0) {
  const $ = _c(22);
  const {
    canManageSite
  } = t0;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex lg:hidden"><Button type="button" className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-slate-700" onClick={() => setMobileMenuOpen(true)}><Bars3Icon className="h-6 w-6" /></Button></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMobileMenuOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/25" /></TransitionChild>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex lg:flex-1"><Link href="/" className="-m-1.5 p-1.5"><span className="sr-only">AlgoAcademy</span><AlgoAcademyHorizontalLogo className="h-8 w-auto" /></Link></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setMobileMenuOpen(false);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center justify-between">{t4}<Button type="button" className="-m-2.5 rounded-md p-2.5 text-slate-700" onClick={t5} aria-label="Close menu"><XMarkIcon className="h-6 w-6" aria-hidden="true" /></Button></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t10;
  let t11;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MobileMenuDisclosure title="O nas" items={aboutLinks} />;
    t8 = <MobileMenuDisclosure title="Mentoring" items={mentoringLinks} />;
    t9 = <MobileMenuDisclosure title={"Kursy (szko\u0142a podstawowa)"} items={elementarySchoolCourses} />;
    t10 = <MobileMenuDisclosure title={"Kursy (szko\u0142a \u015Brednia)"} items={highSchoolCourses} />;
    t11 = <MobileMenuDisclosure title="Kursy (studia)" items={universityCourses} />;
    $[6] = t10;
    $[7] = t11;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[6];
    t11 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <MobileMenuLink href="/kursy" title="Wszystkie kursy" onClick={() => setMobileMenuOpen(false)} />;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  let t14;
  let t15;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <MobileMenuLink href="/kontakt" title="Kontakt" onClick={() => setMobileMenuOpen(false)} />;
    t14 = <MobileMenuLink href="/baza" title={"Baza wiedzy \u2192"} isHighlighted={true} />;
    t15 = <MobileMenuLink href="/app" title={"Aplikacja \u2192"} isHighlighted={true} />;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
  } else {
    t13 = $[12];
    t14 = $[13];
    t15 = $[14];
  }
  let t16;
  if ($[15] !== canManageSite) {
    t16 = canManageSite && <MobileMenuDisclosure title={"Zarz\u0105dzaj stron\u0105"} items={manageSiteLinks} />;
    $[15] = canManageSite;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== t16) {
    t17 = <Dialog as="div" className="lg:hidden" onClose={t2}>{t3}<TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"><DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-slate-900/10">{t6}<nav className="mt-6 flow-root"><div className="-my-6 divide-y divide-slate-500/10"><div className="space-y-2 py-6">{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div></div></nav></DialogPanel></TransitionChild></Dialog>;
    $[17] = t16;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== mobileMenuOpen || $[20] !== t17) {
    t18 = <>{t1}<Transition show={mobileMenuOpen} as={Fragment}>{t17}</Transition></>;
    $[19] = mobileMenuOpen;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  return t18;
}